import React from 'react'
import styled from 'styled-components'
import {Box, Switch, VisuallyHidden, themeGet} from '@fuegokit/react'

const StyledSwitchExample = () => {
  return (
    <Box as="form" sx={{display: 'flex', alignItems: 'center', gap: 2}}>
      <StyledLabel htmlFor="airplane-mode">Airplane mode</StyledLabel>
      <StyledSwitch id="airplane-mode">
        <StyledSwitchThumb>
          <VisuallyHidden>Airplane mode</VisuallyHidden>
        </StyledSwitchThumb>
      </StyledSwitch>
    </Box>
  )
}
const StyledLabel = styled.label`
  color: ${themeGet('colors.text.default')};
  font-size: ${themeGet('fontSizes.2')};
  line-height: ${themeGet('lineHeights.condensed')};
  padding-right: ${themeGet('space.2')};
`
const StyledSwitch = styled(Switch)`
  all: unset;
  //
  width: ${themeGet('space.7')};
  height: 28px;
  background-color: ${themeGet('colors.background.neutral.bold.default')};
  border-radius: ${themeGet('radii.4')};
  position: relative;
  /* box-shadow: 0 2px 10px ${themeGet('colors.background.neutral.bold.default')}; */
  -webkit-tap-highlight-color: ${themeGet('colors.background.neutral.bold.default')};
  &:focus {
    box-shadow: 0 0 0 2px ${themeGet('colors.border.focused')};
  }
  &[data-state='switched'] {
    background-color: ${themeGet('colors.neutral.bold.default')};
  }
`
const StyledSwitchThumb = styled(Switch.Thumb)`
  display: block;
  width: 24px;
  height: 24px;
  background-color: ${themeGet('colors.background.input.default')};
  border-radius: 9999px;
  box-shadow: 0 2px 2px ${themeGet('colors.background.neutral.bold.default')};
  transition: transform 100ms;
  transform: translateX(2px);
  will-change: transform;
  &[data-state='checked'] {
    transform: translateX(23px);
  }
`
export default StyledSwitchExample
